/** 券类型：1-满减券 2-折扣券 */
export const COUPON_TYPE = {
  1: '满减券',
  2: '折扣券'
}

/** 状态：0-未生效 1-生效中 2-已过期 3-提前结束 */
export const COUPON_STATUS = {
  0: '未生效',
  1: '生效中',
  2: '已过期',
  3: '提前结束'
}

/** 派券方式：1-商品页领取 2-分享页领取 3-弹窗领取 4-支付后领取 5-批量派发 */
export const DISTRIBUTE_WAY = {
  1: '商品页领取',
  2: '分享页领取',
  3: '弹窗领取',
  4: '支付后领取',
  5: '批量派发'
}

export function toSelectOptions (map) {
  return Object.keys(map).map(k => ({ label: map[k], value: Number(k) }))
}
